import { CarModel, DriverWorkCycle, EvCar } from "../common";
import { Office } from "../office";

export type Car = {
  id: number;
  evCars: EvCar;
  officeId: number;
  office: Office;
  carModelId: number;
  carModels: CarModel;
  driverAppKitId?: number;
  vehicleCode?: string;
  plateNumberFullText?: string;
  capable?: number;
  serviceStatus?: number;
  deletedAt?: string;
  linkedAt: string;
  version: number;
};

export type CarList = {
  id: number;
  officeId: number;
  evCarId: number;
  vehicleCode: string;
  plateNumberFullText?: string;
  officeDisplayName: string;
  carModelsDisplayName: string;
  usageStartOn: string;
  usageEndOn: string;
  socPercent: number | null;
  socLastCollectedAt: string;
  frontShortName: string;
  backShortName: string;
};

export type EvCarRequest = {
  carId: number;
  evCarModelId: number;
  imei: string;
  imei2: string;
  usageStartOn: string;
  usageEndOn?: string;
  frontDriverWorkCycleId: number;
  frontDriverWorkCycleBaseDate: string;
  frontDriverWorkCycleApplyOn: string;
  backDriverWorkCycleId?: number;
  backDriverWorkCycleBaseDate: string;
  backDriverWorkCycleApplyOn: string;
  subsidyType: string;
  excludedFromNumberOfCars: boolean;
  officeLocationsId?: number;
  version: number;
  chargeCardEvs?: {
    id?: number;
    chargeCardId: number;
    cause: string;
    version: number;
  };
  gochargeCardEv?: {
    gochargeCardId: number;
    startOn: string;
    endOn?: string;
  };
  socUpdate?: boolean;
  previousEvCarId?: number;
};

export type CarSortKey =
  | "officeDisplayName"
  | "carModelsDisplayName"
  | "vehicleCode"
  | "usageStartOn"
  | "socPercent";

export type CarOrder = {
  [key in CarSortKey]?: "asc" | "desc" | undefined;
};

export type EvCarError = {
  [key in keyof EvCar]?: boolean;
} & {
  cause?: boolean;
  gochargeCardStartOn?: boolean;
  gochargeCardEndOn?: boolean;
};

export type DateRanges = {
  start: boolean;
  end: boolean;
};

export const REGISTERED = "REGISTERED";
export const WITHIN_PERIOD = "WITHIN_PERIOD";
export const NOT_REGISTERED = "NOT_REGISTERED";
export type FilterType =
  | typeof REGISTERED
  | typeof WITHIN_PERIOD
  | typeof NOT_REGISTERED;

export type SearchCarsCondition = {
  officeIds?: number[];
  vehicleCode?: string;
  carFilter?: FilterType;
};

export type GxFilter = {
  readonly type: FilterType;
  readonly display: string;
};

export type SavedState = {
  officesSelected: Office[];
  vehicleCode: string;
  page: number;
  order: CarOrder;
  searchCondition: SearchCarsCondition;
};

export type EvCarLinkedDriverWorkCycles = {
  evCarId: number;
  frontDriverWorkCycles?: DriverWorkCycle;
  backDriverWorkCycles?: DriverWorkCycle;
};
